import PropTypes from 'prop-types'
import React from 'react'

import Buybox, { AddToCartButton, BuyboxQuantityField } from '../../templateComponents/Buybox'

export default function Product({ product, t }) {
  return (
    <div className="template-product">
      <div>{product.name}</div>
      {product.image && (
        <div>
          <img src={product.image.url} />
        </div>
      )}
      <div>
        <div>{t(product.availabilityText)}</div>
        {product.price && <div>{product.price.formatted}</div>}
        {product.basePrice && <div>{product.basePrice.formatted}</div>}
        <Buybox redirectToCart product={product}>
          <div>
            <div className="buybox-quantity-field">
              <BuyboxQuantityField />
            </div>
            <div className="add-to-cart-button">
              <AddToCartButton>Add to cart</AddToCartButton>
            </div>
          </div>
        </Buybox>
      </div>
    </div>
  )
}

Product.propTypes = { product: PropTypes.object.isRequired, t: PropTypes.func.isRequired }
